/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
import axios from 'axios';
import { API_BASE_URI } from '../utils/apiEndPoint';

// use url with /ecr_tbms/ to use proxy (declared respective api calls)

export const submitEarlyForm = (userConfig, response) => {
  if (userConfig === null || userConfig === undefined) {
    userConfig = JSON.parse(sessionStorage.getItem('login_details'));
  }
  return new Promise((resolve, reject) => {
    const { studentId } = userConfig;
    const { birthdate } = userConfig;
    const url = `${API_BASE_URI}/saveEarlyLeaveFormData/ecr`;

    const params = new URLSearchParams();
    params.append('studentid', studentId);
    params.append('birthdate', birthdate);

    axios({
      method: 'post',
      url,
      data: {
        student_id: studentId,
        periods: response.periods,
        leave_date: response.leave_date,
        reason: response.reason,
        alternate_number: response.alternate_number,
        release_time: response.release_time,
        comments: response.comments,
        parent_name: response.parent_name,
        relationship: response.relationship,
      },
    })
      .then((response1) => {
        if (response1.data.hasOwnProperty('status')) {
          resolve(response1.data);
        } else {
          reject(response1.data);
        }
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const getAbsencesData = (userConfig, userData) => {
  if (userConfig === null || userConfig === undefined) {
    userConfig = JSON.parse(sessionStorage.getItem('login_details'));
  }
  return new Promise((resolve, reject) => {
    const { studentId } = userConfig;
    const url = `${API_BASE_URI}/getAbsencesData/ecr`;

    const params = new URLSearchParams();
    params.append('studentid', studentId);

    let data;
    if (userData && Object.keys(userData).length !== 0) {
      data = userData;
    } else {
      data = {
        student_id: studentId,
      };
    }

    axios({ method: 'post', url, data })
      .then((response) => {
        if (response.data.hasOwnProperty('status')) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const submitAbsenceForm = (userConfig, response) => {
  if (userConfig === null || userConfig === undefined) {
    userConfig = JSON.parse(sessionStorage.getItem('login_details'));
  }
  return new Promise((resolve, reject) => {
    const { studentId } = userConfig;
    const { birthdate } = userConfig;
    const url = `${API_BASE_URI}/saveAbsenceClearanceFormData/ecr`;

    const params = new URLSearchParams();
    params.append('studentid', studentId);
    params.append('birthdate', birthdate);

    axios({
      method: 'post',
      url,
      data: {
        token: response.token,
        student_id: studentId,
        periods: response.periods,
        absence_date: response.absence_date,
        reason: response.reason,
        // contact_id: response.contact_id,
        // parent_name: response.parent_name,
        // relationship: response.relationship,
      },
    })
      .then((response1) => {
        if (response1.data.hasOwnProperty('status')) {
          resolve(response1.data);
        } else {
          reject(response1.data);
        }
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};
